export const environment = {
  apiUrl: "https://api.admefy.com/api/v1/player",
  websiteUrl: "https://app.admefy.com",
  wsAPIUrl: "https://ws.admefy.com",
  analyticsProxyUrl: "https://analytics.admefy.com",
  centrifugoUrl: "wss://centrifugo.admefy.com/connection/websocket",
  centrifugoEnabled: true,
  sentryDsn:
    "https://8c8f942be37e5551ba0c82b76dd31f42@o295403.ingest.us.sentry.io/4507656259174400",
  serviceWorkerEnabled: true,
  production: true,
};
